/** Sets <html data-sky> from the hour and data-theme="dusk" from the system. Light is always the default. */
export function applySky(now = new Date()) {
  const h = now.getHours();
  const sky = h >= 4 && h < 10 ? 'sunrise' : h >= 10 && h < 16 ? 'midday' : 'golden';
  const root = document.documentElement;
  root.setAttribute('data-sky', sky);
  if (window.matchMedia('(prefers-color-scheme: dark)').matches) root.setAttribute('data-theme', 'dusk');
  else root.removeAttribute('data-theme');
  const themeColor = document.querySelector('meta[name="theme-color"]');
  if (themeColor) themeColor.setAttribute('content', getComputedStyle(root).getPropertyValue('--sky-top').trim());
}

export function watchSky() {
  applySky();
  const mq = window.matchMedia('(prefers-color-scheme: dark)');
  mq.addEventListener('change', () => applySky());
  const id = window.setInterval(() => applySky(), 10 * 60 * 1000);
  return () => window.clearInterval(id);
}
